export default __webpack_public_path__ + "static/media/media-audio.e67d2f6a.svg";